import React, { useState } from 'react';
import MenuItem from "../menu-item";
import styles from "./MenuGroup.module.css"
const MenuGroup = ({ group }) => {
    const [isExpanded, setIsExpanded] = useState(group.expanded);
    if (isExpanded) {
        return (
            <div className={styles.menu_group_container}>
                {group.name &&
                    <div className={styles.menu_group_caption} onClick={() => {
                        setIsExpanded(false)
                    }}>
                        <div className={styles.menu_group_caption_text}>
                            {group.name}
                        </div>

                        <div className={styles.menu_group_caption_dropdown_icon}>
                            <i className="fas fa-chevron-up"></i>
                        </div>

                    </div>
                }
                <div className={styles.menu_group}>
                    {group.items && group.items.map((x, idx) => {
                        return (
                            <MenuItem key={idx} item={x} isFirstOfGroup={idx == 0} isLastOfGroup={idx == group.items.length - 1} />
                        );
                    })}
                </div>
            </div>
        );
    } else {
        return (
            <div className={styles.menu_group_collapse_container} onClick={() => {
                setIsExpanded(true)
            }}>
                <div className={styles.icon}>
                    <i className={group.icon}></i>
                </div>
                <div className={styles.text}>
                    {group.name}
                </div>
                <div className={styles.dropdown_icon}>
                    <i className="fas fa-chevron-down"></i>
                </div>
            </div>
        );
    }
};

export default MenuGroup;